


<div class="container">
    <form class="page initial-state justify-center">
        <h1 class="title">Resetear contraseña</h1>
        <div class="page-box">
            <mat-form-field class="page-form-control" appearance="outline">
                <mat-label>Dirección de correo</mat-label>
                <input matInput type="email" #passwordResetEmail>
            </mat-form-field>

            <button mat-raised-button color="primary" class="page-button" (click)="authService.forgotPassword(passwordResetEmail.value)">Resetear</button>
            <span class="page-text">
                ¿Deseas volver?
                <div class="page-link" routerLink="/sign-in">Log In</div>
            </span>
        </div>
    </form>
    <img src="assets/safaera_login_image.jpg"  class="login-image" alt="a man in a concert doing rock signs">
</div>
